export const style = {
  cardContainer: {
    marginBottom: "1.6rem",
    padding: "1.2rem 0.8rem",
    borderRadius: "0.8rem",
    background: "var(--neutral-100)",
    backgroundColor: "var(--neutral-100)",
  },
  patientDetail: {
    borderTop: "0.1rem solid var(--gray-20)",
    margin: "0.8rem 0rem",
  },
  detail: {
    display: "flex",
    alignItems: "center",
    gap: "0.2rem",
    marginTop: "0.6rem",
    color: "var(--gray-500)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
  hideOrShowBlock: {
    display: { xs: "none", md: "block" },
  },
  callButton: {
    display: { xs: "block", md: "none" },
    width: "100%",
  },
  mapText: {
    color: "var(--orange-500)",
    fontSize: "1.2rem",
    fontWeight: 500,
    cursor: "pointer",
  },
  clinicInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.8rem",
  },
  clinicLocation: {
    display: "flex",
    alignItems: "center",
    gap: "0.8rem",
  },
  buttonContainer: {
    marginTop: "0.8rem",
    display: "flex",
    gap: "0.8rem",
  },
};
